import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('casaTypesCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/products/casa/types'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.casaTypes,
    cacheName: 'casaTypes'
  })
);
